export default "__VITE_ASSET__CMy7w1WT__"